import Block from '../block'

export default class Form extends Block {
	static title = 'form'

	constructor($el) {
		super($el)

		this.firstname = this.$el.find('input[name="firstname"]')
		this.lastname = this.$el.find('input[name="lastname"]')
		this.submitButton = this.$el.find('button[type="submit"]')
		this.nameMessage = this.$el.findElement('name-message')

		if (this.$el.hasModifier('autosubmit')) {
			this.$el.find(':input').change(() => {
				this.$el.submit()
			})
		}

		if (this.firstname && this.lastname && this.nameMessage) {
			this.firstname.add(this.lastname).on('blur', () => {
				const combinedName = this.firstname.val() + this.lastname.val()
				if (combinedName.length > 35) {
					this.submitButton.prop('disabled', true)
					this.firstname.parent().addClass('mdc-text-field--invalid')
					this.lastname.parent().addClass('mdc-text-field--invalid')
					this.nameMessage.addClass('form__name-message--active')
				} else {
					this.submitButton.prop('disabled', false)
					this.firstname.parent().removeClass('mdc-text-field--invalid')
					this.lastname.parent().removeClass('mdc-text-field--invalid')
					this.nameMessage.removeClass('form__name-message--active')
				}
			})
		}
	}
}
